import { Button, Card, Heading, Text } from "@/design-system";
import { Link } from "react-router";
import type { ToolSummary } from "../constants";

type ToolCardProps = {
  tool: ToolSummary;
};

/** Cartão do hub /ferramentas: o que a ferramenta faz e o botão para abrir. */
export const ToolCard = ({ tool }: ToolCardProps) => (
  <Card className="flex h-full flex-col items-start gap-3">
    <Heading level={2} size={3}>
      {tool.name}
    </Heading>
    <Text tone="muted" className="flex-1">
      {tool.summary}
    </Text>
    <Button asChild variant="secondary" navigates="internal" className="mt-2">
      <Link to={tool.path}>{tool.cta}</Link>
    </Button>
  </Card>
);
